import { useFormik } from "formik";
import React from "react";
import * as yup from "yup"
import { login, setLoggedIn } from "../../store/slice/auth";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { notifyError, notifySuccess } from "../../hook/notification";
import useDialogState, { Loader } from "../../hook";
import { ToastContainer } from "react-toastify";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    loader: loader,
    handleClickOpen: setLoader,
    handleClose: unSetLoader,
  } = useDialogState();

  const schema = yup.object().shape({
    email: yup.string().email().required("Enter your email"),
    password: yup.string().required("Enter your password"),
  });

  const submit = async (values, action) => {
    const { email, password } = values;
    try {
      setLoader()
      await dispatch(login({ email, password })).unwrap();
      notifySuccess("Login successfully")
      setTimeout(() => {
        dispatch(setLoggedIn(true));
        localStorage.setItem("isLoggedIn", JSON.stringify(true));
        unSetLoader()
        navigate('/dashboard/')
        action.resetForm();
      }, 1500);
    } catch (e) {
      notifyError(e.response.data.apierror.message)
      setTimeout(() => {
        unSetLoader()
      }, 1500);
    }
  };

  const initialValue = {
    email: "",
    password: "",
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  return (
    <>
      <div class="flex h-screen flex-col justify-center">
        <div className="max-w-[500px] w-full mx-auto p-4">
          <div class="sm:mx-auto sm:w-full sm:max-w-sm">
            <h2 class="text-center text-2xl font-bold leading-9 tracking-tight text-white">
              Sign in to your account
            </h2>
          </div>

          <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form onSubmit={formik.handleSubmit} class="space-y-6" action="#" method="POST">
              <div className="flex flex-col gap-2">
                <label for="email" class="label">
                  Email address
                </label>
                <input
                  id="email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  type="email"
                  autocomplete="email"
                  required
                  class="input"
                />
                {formik.errors.email && formik.touched.email &&
                  <div className="text-red text-sm mb-4">{formik.errors.email}</div>
                }
              </div>

              <div className="flex flex-col gap-2">
                <label for="password" class="label">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  type="password"
                  autocomplete="current-password"
                  required
                  class="input"
                />
                {formik.errors.password && formik.touched.password &&
                  <div className="text-red text-sm mb-4">{formik.errors.password}</div>
                }
              </div>

              <div>
                <button
                  type="submit"
                  class="w-full p-2 bg-blue rounded-6 text-white"
                >
                  {loader ? <Loader /> : "Sign in"}
                </button>
              </div>
            </form>
          </div>
        </div>
        <ToastContainer autoClose={1500} />
      </div>
    </>
  );
};

export default Login;
